/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Task_Status_In_ProgressInputs */

const en_attribute_task_status_in_progress = /** @type {(inputs: Attribute_Task_Status_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Attribute_Task_Status_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_task_status_in_progress = /** @type {((inputs?: Attribute_Task_Status_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Task_Status_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_task_status_in_progress(inputs)
});